import { isDefined } from "@clipboard-health/util-ts";

import { MESSAGE_CUSTOM_TYPES } from "../constants";
import type { AdminChatMessage } from "../types";
import { parseFcmRequestMessageData } from "../utils/parseFcmRequestMessage";
import { FcmRequestMessage } from "./FcmRequestMessage";

interface FcmRequestMessageRouterProps {
  message: AdminChatMessage;
  workplaceId: string;
  workplaceUserId?: string;
}

/**
 * Routes FCM (Facility Canceled Me / Sent Home) request messages to the display component.
 * Parses the message data and renders the FcmRequestMessage component with the appropriate props.
 * Returns null if the message is not an FCM_REQUEST or if data parsing fails.
 */
export function FcmRequestMessageRouter(
  props: FcmRequestMessageRouterProps
): React.ReactElement | null {
  const { message, workplaceId, workplaceUserId } = props;

  if (message.customType !== MESSAGE_CUSTOM_TYPES.FCM_REQUEST) {
    return null;
  }

  const parsedData = parseFcmRequestMessageData(message.data, message.message);

  // Don't render if data integrity fails or worker name is missing
  if (!isDefined(parsedData) || !isDefined(parsedData.workerName)) {
    return null;
  }

  return (
    <FcmRequestMessage
      messageId={String(message.messageId)}
      channelUrl={message.channelUrl}
      shiftId={parsedData.shiftId}
      approvalStatus={parsedData.approvalStatus}
      workerName={parsedData.workerName}
      description={parsedData.description}
      workplaceId={workplaceId}
      workplaceUserId={workplaceUserId}
    />
  );
}
